// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3zMBj","selects":"Documents_selects__11lJx"};